import OneSignalError from "./OneSignalError";
export var SubscriptionErrorReason;
(function (SubscriptionErrorReason) {
    SubscriptionErrorReason[SubscriptionErrorReason["InvalidSafariSetup"] = 0] = "InvalidSafariSetup";
    SubscriptionErrorReason[SubscriptionErrorReason["Blocked"] = 1] = "Blocked";
    SubscriptionErrorReason[SubscriptionErrorReason["Dismissed"] = 2] = "Dismissed";
})(SubscriptionErrorReason || (SubscriptionErrorReason = {}));
export default class SubscriptionError extends OneSignalError {
    constructor(reason) {
        switch (reason) {
            case SubscriptionErrorReason.InvalidSafariSetup:
                super('The Safari site URL, icon size, or push certificate is invalid, or Safari is in a private session.');
                break;
            case SubscriptionErrorReason.Blocked:
                super('Notification permissions are blocked.');
                break;
            case SubscriptionErrorReason.Dismissed:
                super('The notification permission prompt was dismissed.');
                break;
        }
    }
}
//# sourceMappingURL=SubscriptionError.js.map